export default (locationInfo) => {
  const { region, description } = locationInfo;
  const city = region && region.indexOf(',') > 0 && region.split(',')[0];

  if (city) {
    const street = description;

    if (street) {
      return `${city} on ${street}`;
    }

    return city;
  }

  return '';
};
